
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/projects/oasis",
      function () {
        return require("private-next-pages/projects/oasis/index.page.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/projects/oasis"])
      });
    }
  